import React from 'react';
import { Gift, TrendingUp } from 'lucide-react';

/**
 * v226 Masterplan Abgasanlagen:
 * Automatischer 50 € Zusatzrabatt ab 2500 € Warenwert.
 * - Zeigt "unlocked" wenn erreicht
 * - Zeigt Progress-Bar mit fehlendem Betrag wenn kurz davor
 * - Blendet komplett aus wenn Warenwert < THRESHOLD * 0.5 (kein Nudging bei Kleinstwarenkorb)
 */

export const VOLUME_DISCOUNT_THRESHOLD = 2500;
export const VOLUME_DISCOUNT_AMOUNT = 50;

export function calcVolumeDiscount(subtotal) {
  return (Number(subtotal) || 0) >= VOLUME_DISCOUNT_THRESHOLD ? VOLUME_DISCOUNT_AMOUNT : 0;
}

function fmt(n) {
  return (Number(n) || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

export default function VolumeDiscountBadge({ subtotal = 0, placement = 'cart', style = {} }) {
  const sub = Number(subtotal) || 0;
  const unlocked = sub >= VOLUME_DISCOUNT_THRESHOLD;
  const remaining = Math.max(0, VOLUME_DISCOUNT_THRESHOLD - sub);
  const progress = Math.min(100, Math.round((sub / VOLUME_DISCOUNT_THRESHOLD) * 100));

  // Verstecke wenn Warenkorb sehr klein - kein Nudging
  if (!unlocked && sub < VOLUME_DISCOUNT_THRESHOLD * 0.25) return null;

  if (unlocked) {
    return (
      <div data-testid="volume-discount-unlocked" style={{
        background: 'linear-gradient(90deg, rgba(34,197,94,0.22) 0%, rgba(34,197,94,0.10) 100%)',
        border: '1px solid rgba(34,197,94,0.55)',
        color: '#4ade80',
        padding: '12px 14px', borderRadius: 10,
        display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontWeight: 600,
        margin: '10px 0', ...style,
      }}>
        <Gift size={20} />
        <div>
          <div style={{ fontSize: 14 }}>Freigeschaltet: <strong style={{ color: '#22c55e' }}>{fmt(VOLUME_DISCOUNT_AMOUNT)}</strong> Zusatzrabatt!</div>
          <div style={{ fontSize: 11, fontWeight: 400, opacity: 0.85, marginTop: 2 }}>
            Ab {fmt(VOLUME_DISCOUNT_THRESHOLD)} Warenkorbwert – wird automatisch abgezogen.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="volume-discount-progress" style={{
      background: 'rgba(236, 34, 41, 0.08)',
      border: '1px solid rgba(236, 34, 41, 0.35)',
      padding: '10px 12px', borderRadius: 10,
      margin: '10px 0', ...style,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: 12.5, color: '#f5f5f5' }}>
        <TrendingUp size={16} style={{ color: '#EC2229' }} />
        <span>Nur noch <strong style={{ color: '#EC2229' }}>{fmt(remaining)}</strong> bis {fmt(VOLUME_DISCOUNT_AMOUNT)} Extra-Rabatt</span>
      </div>
      <div style={{ height: 6, background: 'rgba(255,255,255,0.08)', borderRadius: 999, overflow: 'hidden' }}>
        <div style={{
          width: `${progress}%`, height: '100%',
          background: 'linear-gradient(90deg, #EC2229 0%, #ff6b6b 100%)',
          transition: 'width 0.4s ease-out',
        }} />
      </div>
    </div>
  );
}
